import React, { Component } from 'react';
import $ from 'jquery';
import { findDOMNode } from 'react-dom';

export default class LogansWar extends Component {

toggle = () => {
    let toggle = findDOMNode(this.refs.toggle);
    $(toggle).toggle();
}

	render() {
		return (
			<div>
                <iframe id="video" ref="toggle" src="https://www.youtube.com/embed/9mmwlDt97wE" 
                title="Logan's War"></iframe>
				<button
					type="button"
					className="btn logansWar"
					onClick={this.toggle}
				>
					Logan's War
				</button>
			</div>
		);
	}
}
